import moment from "moment";

const getDate = (params) => {
  let { date } = params;
  date = date ? moment(date) : moment();

  return date.isValid() ? date : moment();
};

export default getDate;
